import notification from 'ant-design-vue/es/notification'

const service = axios.create({
  baseURL: '/prod-api',
  timeout: 20000
})

service.interceptors.request.use(
  response => {
    response.headers['auth'] = localStorage.getItem('TZMH_TOKEN')
    return response
  }
)

service.interceptors.response.use(
  response => {
    if (response.data.code !== 200) {
      let error = response.data
      return Promise.resolve(error)
    } else {
      return Promise.resolve(response.data)
    }
  },
  err => {
    if (err.response) {
      switch (err.response.status) {
        case 500:
          err.response.message = '服务器错误，链接失败（500）'
          notification.error({
            message: '500',
            description: '服务器错误，链接失败（500）'
          })
          break;
        case 404:
          err.response.message = '接口地址错误（404）'
          notification.error({
            message: '404',
            description: '接口地址错误（404）'
          })
          break;
        case 401:
          err.response.message = '请求超时（401）'
          notification.error({
            message: '401',
            description: '请求超时（401）'
          })
          break;
      }
    }
    return Promise.reject(err.response)
  }
)

export {
  service as axios
}